import { PendingSummaryRef } from 'pbts/c1/api/accessreview/v1/accessreview_pending'
import { AccessReviewPendingActionsServiceClient } from 'pbts/c1/api/accessreview/v1/accessreview_pending.client'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createUnaryApi, createUnaryApiNoCache } from 'redux_toolkit/lib/createUnaryApi'

// Mutation APIs (state-changing operations)
export const upsertPendingActionApi = createMutationApi(
    AccessReviewPendingActionsServiceClient,
    'upsertPendingAction',
)

export const removePendingActionApi = createMutationApi(
    AccessReviewPendingActionsServiceClient,
    'removePendingAction',
)

export const discardAllPendingApi = createMutationApi(
    AccessReviewPendingActionsServiceClient,
    'discardAllPending',
)

export const discardPendingBySearchApi = createMutationApi(
    AccessReviewPendingActionsServiceClient,
    'discardPendingBySearch',
)

export const submitReviewApi = createMutationApi(
    AccessReviewPendingActionsServiceClient,
    'submitReview',
)

export const initiateStepUpForSubmitApi = createMutationApi(
    AccessReviewPendingActionsServiceClient,
    'initiateStepUpForSubmit',
)

export const validatePendingActionsApi = createUnaryApiNoCache(
    AccessReviewPendingActionsServiceClient,
    'validatePendingActions',
)

// Query APIs (read-only operations with caching)
export const getPendingSummaryApi = createUnaryApi(
    AccessReviewPendingActionsServiceClient,
    'getPendingSummary',
    undefined,
    PendingSummaryRef.typeName,
)

export const getPendingActionsByTaskIdsApi = createUnaryApi(
    AccessReviewPendingActionsServiceClient,
    'getPendingActionsByTaskIDs',
)

export const getSubmissionStatusApi = createUnaryApi(
    AccessReviewPendingActionsServiceClient,
    'getSubmissionStatus',
)

export const listPendingActionsApi = createPagedListApi(
    AccessReviewPendingActionsServiceClient,
    'listPendingActions',
)

export const listSubmissionsApi = createPagedListApi(
    AccessReviewPendingActionsServiceClient,
    'listSubmissions',
)

export const getLatestSubmissionApi = createUnaryApi(
    AccessReviewPendingActionsServiceClient,
    'getLatestSubmission',
)

export const searchSubmissionsApi = createPagedListApi(
    AccessReviewPendingActionsServiceClient,
    'searchSubmissions',
)

export const searchSubmissionsByAdminApi = createPagedListApi(
    AccessReviewPendingActionsServiceClient,
    'searchSubmissionsByAdmin',
)
